module.exports = __webpack_public_path__ + "img/ban6.92c337df.jpg";